<script lang="ts" setup>
    import GlobalSearchItem from '@/app/common/models/GlobalSearchItem';

    const props = defineProps<{
        result: GlobalSearchItem;
    }>();
</script>

<template>
    <AppSearchModalResult
        icon="fa-hard-hat"
        :result="result"
    >
        <template v-slot>
            <span class="block text-sm text-gray-800">
                {{ result.title }}
            </span>
            <span class="block text-xs text-gray-600">
                {{ result.worksite.startsAt.toEUDateString() }} - {{ result.worksite.endsAt.toEUDateString() }}
                <span v-if="result.contact"> - {{ result.contact?.displayName }} </span>
            </span>
        </template>
        <template v-slot:right>
            <UsersAvatarList
                :users="result.worksite.managers"
                size="w-[24px] h-[24px]"
            />
        </template>
    </AppSearchModalResult>
</template>
